import { app } from '@df/core/app';
import { TDropEffect, TEffectAllowed } from '@df/ui/drag/drag.interface';

export function calculateDragImageOffset(event: DragEvent, dragImage: Element): { x: number; y: number } {
    const window = app.window;
    const dragImageComputedStyle = window.getComputedStyle(dragImage);
    const paddingTop = parseFloat(dragImageComputedStyle.getPropertyValue('padding-top')) || 0;
    const paddingLeft = parseFloat(dragImageComputedStyle.getPropertyValue('padding-left')) || 0;
    const borderTop = parseFloat(dragImageComputedStyle.getPropertyValue('border-top-width')) || 0;
    const borderLeft = parseFloat(dragImageComputedStyle.getPropertyValue('border-left-width')) || 0;

    return {
        x: event.offsetX + paddingLeft + borderLeft,
        y: event.offsetY + paddingTop + borderTop
    };
}

export function filterEffects(effects: TDropEffect[], allowed: TEffectAllowed | TDropEffect): TDropEffect[] {
    if (allowed === 'all' || allowed === 'uninitialized') {
        return effects;
    }

    return effects.filter(function (effect) {
        return allowed.toLowerCase().indexOf(effect) !== -1;
    });
}

export function getDirectChildElement(parentElement: Element, childElement: Element): Element | null {
    let directChild: Node = childElement;

    while (directChild.parentNode !== parentElement) {
        // reached root node without finding given parent
        if (!directChild.parentNode) {
            return null;
        }

        directChild = directChild.parentNode;
    }

    return directChild as Element;
}

export function shouldPositionPlaceholderBeforeElement(event: DragEvent, element: Element, horizontal: boolean) {
    const bounds = element.getBoundingClientRect();

    // If the pointer is in the upper half of the list item element,
    // we position the placeholder before the list item, otherwise after it.
    if (horizontal) {
        return event.clientX < bounds.left + bounds.width / 2;
    }

    return event.clientY < bounds.top + bounds.height / 2;
}
